import { Table, Button, Popover, Tag } from "antd";
import { BarcodeOutlined, RedoOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
// import { ItemBillsInterface } from "../Interfaces/ItemBillInterface";
import { Bill, BillItemType } from './Types'
import { useNavigate, useParams } from "react-router";
import { useState } from "react";
import { SerialNumber } from "./SerialnumberModal";
import { deleteBillItem, getBillById, getBillItemById } from "../../api/bills";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import EditButton from "../UI/EditButton/editbutton";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";
import { Pagination } from "./Types";


interface BillItem {
  id: number;
  item: Item;
  quantity: number;
  price: number;
  sales: number | null;
  lastPrice: number | null;
  lastSales: number | null;
  priceText: string;
  expirationDate: number;
  isTaxable: boolean;
  tax: number;
  discount: number;
  discountType: string | null;
  notes: string;
  isReturned: boolean;
  returnedQuantity: number;
}
interface Item {
  id: number;
  name: string;
  barcode: string;
  category: {
    id: number;
    name: string;
    description: string;
    isActive: boolean;
  };
  description: string;
  image: string | null;
  sku: string;
  isActive: boolean;
}
interface ItemProps {
  tableKey: number;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  handleDeleteRefresh: any;
  isItemBillLoading: boolean;
  handleTableChange: React.Dispatch<any>;
  pagination: Pagination;
  disabled: boolean;
  invoiceNo: number;
  billItems: BillItem[] | undefined,
  bill: Bill | undefined
}

const ItemBillLists = ({
  tableKey,
  handleDeleteRefresh,
  billItems,
  isItemBillLoading,
  handleTableChange,
  pagination,
  disabled,
  invoiceNo,
  bill
}: ItemProps) => {
  const navigate = useNavigate();
  const [openSerial, setOpenSerial] = useState(false);
  const [t] = useTranslation("common");

  const billId = useParams().billId;

  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);

  const { mutateAsync: deleteBillItemMutation } = useMutation(
    "deleteBillItem",
    (itemId: number) => deleteBillItem(billId, itemId)
  );

  const { mutateAsync: getBillItemsMutation } = useMutation(
    "getBillItems",
    () => getBillById(Number(billId))
  );

  const { mutateAsync: getBillItemMutation } = useMutation(
    "getBillItem",
    (itemId: number) => getBillItemById(billId, itemId)
  );

  const DeleteBillTable = (id: number): void => {
    setIdToDelete(id.toString());
    setOpen(true);
  };

  const handleDeleteOk = async () => {
    if (idToDelete) {
      const id = parseInt(idToDelete);
      await deleteBillItemMutation(id)
      await handleDeleteRefresh()
    }
    setOpen(false);
  };

  const handleEditItem = async (itemId: number) => {
    const [billItems, billItem] = await Promise.all([
      getBillItemsMutation(),
      getBillItemMutation(itemId)])

    navigate(`./edit/${itemId}`, {
      state: {
        items: billItems.data.data,
        item: billItem.data,
        disabled,
        invoiceNo,
        bill
      },
    });
  };

  const columns: {}[] = [
    {
      title: `${t("item")}`,
      key: "Items",
      width: "25rem",
      className: "table-header",
      render: (record: BillItemType) => <>{record.item.name}</>,
    },
    {
      title: `${t("barcode")}`,
      key: "barcode",
      width: "10rem",
      className: "table-header",
      render: (record: BillItemType) => <>{record.item.barcode}</>,
    },
    {
      title: `${t("quantity")}`,
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: `${t("price")}`,
      dataIndex: "priceText",
      key: "priceText",
    },
    {
      title: `${t("tax")}`,
      dataIndex: "tax",
      key: "tax",
      render: (tax: string, record: BillItemType) => (record.isTaxable ? tax : 0),
    },
    {
      title: `${t("discount")}`,
      dataIndex: "discount",
      key: "discount",
      render: (discount: string, record: BillItemType) => (record.isDiscountable ? `${discount}${record.discountType}` : 0),
    },
    {
      title: `${t("sales")}`,
      dataIndex: "salesText",
      key: "salesText",
    },
    {
      title: `${t("total-price")}`,
      dataIndex: "totalText",
      key: "totalText",
    },
    {
      title: `${t("profit")}`,
      dataIndex: "profitText",
      key: "profitText",
      render: (profitText: string) => (profitText ? profitText : 0),
    },
    // {
    //   title: `${t("return")}`,
    //   dataIndex: "isReturned",
    //   key: "isReturned",
    //   width: "6rem",
    //   render: (record: any) =>
    //     record ? (
    //       <Tag className="active">Active</Tag>
    //     ) : (
    //       <Tag className="inactive">Inactive</Tag>
    //     ),
    // },
    {
      title: `${t("action")}`,
      key: "action",
      align: "center",
      width: "10rem",
      fixed: "right",
      render: (record: BillItemType) => (
        <>
          {/* <Popover content={<div>{t("barcode")}</div>} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              className="Button"
              type="text"
              icon={
                <BarcodeOutlined
                  style={{ color: "#212121", fontSize: "16px" }}
                />
              }
              onClick={() => setOpenSerial(true)}
            ></Button>
          </Popover> */}
          {/* <Popover content={<>{t("returned")}</>} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              type="text"
              className="Button"
              icon={
                <RedoOutlined style={{ color: "#212121", fontSize: "16px" }} />
              }
            />
          </Popover> */}
          <EditButton onClick={() => handleEditItem(record.id)} disabled={disabled} />
          <DeleteButton onClick={() => DeleteBillTable(record?.id)} disabled={disabled} />
        </>
      ),
    },
  ];

  return (
    <>
      <DeleteModal open={open} setOpen={setOpen} name={""} onOk={handleDeleteOk} />
      <SerialNumber openSerial={openSerial} setOpenSerial={setOpenSerial} />
      <Table
        key={tableKey}
        dataSource={billItems}
        columns={columns}
        loading={isItemBillLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
        onChange={handleTableChange}
        pagination={pagination}
      />
    </>
  );
};
export default ItemBillLists;
